import React from "react";
import { Col, Container, Row } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer" style={{ borderTop: '1px solid #e9ebec', background: '#fff' }}>
        <Container fluid>
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="text-muted fw-medium">
                {new Date().getFullYear()} © <span className="text-primary fw-bold">IKHNUDEN</span>
                <span className="badge badge-soft-info ms-2 px-2">v4.0.2</span>. All rights reserved.
              </div>
            </Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block text-muted">
                Design & Developed by <span className="text-primary fw-semibold" style={{ letterSpacing: '0.5px' }}>w1$D0m</span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
